import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { motion } from 'framer-motion'
import { PiBook } from 'react-icons/pi'

import ButtonLink from '@components/common/Button/ButtonLink'
import ProgressBar from '@components/common/ProgressBar/ProgressBar'

import MotionText from '@/components/common/Motion/MotionText'

import { useKycStore } from '@store/useKycStore'
import MotionDiv from '@/components/common/Motion/MotionDiv'

export const HandbookJournalPage = () => {
  const { t } = useTranslation()

  const progress = useKycStore((state) => state.progress)
  const setProgress = useKycStore((state) => state.setProgress)

  useEffect(() => setProgress(1), [])

  return (
    <div className="h-full bg-white p-5 pt-6 flex flex-col">
      <ProgressBar
        currentStep={progress}
        totalSteps={4}
      />

      <MotionText
        as="h1"
        className="text-base-black text-2xl font-semibold leading-tight mt-6 mb-3"
      >
        {t('handbook.journal.title')}
      </MotionText>
      <MotionText
        as="p"
        className="text-zinc-700 text-xs mb-6 max-w-[18rem]"
      >
        {t('handbook.journal.description')}
      </MotionText>

      <MotionText
        as="h2"
        className="text-base-black text-base font-semibold tracking-tight mb-2"
      >
        {t('handbook.journal.subtitle')}
      </MotionText>

      <MotionText
        as="p"
        className="text-zinc-700 text-sm mb-6"
      >
        {t('handbook.journal.explanation')}
      </MotionText>
      
      <MotionText
        as="h3"
        className="text-base-black text-sm font-semibold tracking-tight mb-4"
      >
        {t('handbook.common.usefulToKnow')}
      </MotionText>

      <MotionDiv className='flex flex-col'>
        <MotionDiv className='flex gap-4'>
          <PiBook className='min-w-6 h-6' />
          <MotionText
            as="p"
            className="text-zinc-700 text-sm"
          >
            {t('handbook.journal.tip1')}
          </MotionText>
        </MotionDiv>
      </MotionDiv>

      <motion.div className="mt-auto w-full space-y-4 flex flex-col">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{
            duration: 0.2,
            ease: "easeOut"
          }}
        >
          <ButtonLink variant='primary' to={'/handbook/taxes'}>
            {t('common.next')}
          </ButtonLink>
        </motion.div>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{
            duration: 0.2,
            ease: "easeOut"
          }}
        >
          <ButtonLink variant='secondary' to={'/'}>
            {t('common.skip')}
          </ButtonLink>
        </motion.div>
        <MotionText
          as="p"
          className="text-zinc-700 text-[0.6rem] text-center"
        >
          {t('handbook.common.findInProfile')}
        </MotionText>
      </motion.div>
    </div>
  )
}

export default HandbookJournalPage